<div class="full-height layout-row padding-5"
     appBringozIdGenerator="agentListItem"
     [ngClass]="{'highlight': isSelected, 'itinerary-view': isItineraryMode}"
     [style.height.px]="isMinimizedData? 70 : 110"
     (click)="onAgentSelect.emit(agent)">

  <div *ngIf="!isItineraryMode"
       class="flex layout-column layout-align-start-center">
    <app-agent-avatar [agent]="agent" class="margin-top-10" size="small"></app-agent-avatar>
  </div>

  <div *ngIf="isItineraryMode"
       class="flex layout-column layout-align-center-center"
       [ngbTooltip]="agent.user | userName"
       openDelay="300" triggers="hover">
    <app-agent-avatar [agent]="agent" size="small"></app-agent-avatar>
  </div>

  <div class="agent-info margin-left-10 flex-65 layout-column layout-align-start-start">

    <div class="info-row layout-row layout-align-start-center">
      <span class="text-ellipsis agent-name br-body-1 font-weight-600"
            [ngbTooltip]="agent.user | userName" openDelay="300" triggers="hover">
                {{agent.user | userName}}
      </span>
      <app-agent-location class="margin-left-5"
                          [agentId]="agent.id"
                          [location]="agent.lastKnownLocation?.coordinates"
                          [locationTrackingApproval]="agent?.locationTrackingApproval"
                          [showText]="false"
                          [gpsStatus]="agent.lastKnownLocation?.deviceReference?.gpsStatus"
                          [gpsPermission]="agent.lastKnownLocation?.deviceReference?.gpsPermission"
                          [lastUpdate]="agent.lastKnownLocation?.updatedAt">

      </app-agent-location>
    </div>

    <div class="info-row layout-row layout-align-start-center">
      <span class="br-body-1 font-weight-400 margin-right-5">{{'AGENT_TYPES.' + agent.agentType | translate}}</span>
      <span appBringozPpi class="br-body-1 font-weight-400">{{agent.user.mobilePhone | bringozPhone}}</span>
    </div>

    <div class="layout-row layout-align-start-center info-row text-ellipsis">
      <bringoz-icon iconName="branch" fill="#7E7E7E" class="margin-right-5"></bringoz-icon>
      <branches-indicator [branches]="agent.branchReferences"></branches-indicator>
    </div>

    <div class="layout-column" *ngIf="!isMinimizedData">

      <div *ngIf="agent.agentReferences" class="info-row layout-row layout-align-start-center">
        <bringoz-icon iconName="assistant" class="margin-right-5" fill="#7E7E7E"></bringoz-icon>
        <app-agent-assistant-mode [agent]="agent"></app-agent-assistant-mode>
      </div>

      <div *ngIf="agent.tags" class="info-row layout-row layout-align-start-center">
        <bringoz-icon iconName="tag-outline" class="margin-right-5" fill="#7E7E7E"></bringoz-icon>
        <app-bringoz-tags [maxTags]="2" [tags]="agent.tags"></app-bringoz-tags>
      </div>

      <div *ngIf="agent.itineraryInfo?.currentLoad?.dimensionsLoadPercent"
           class="info-row layout-row layout-align-start-center">

        <bringoz-icon iconName="volume" class="margin-right-5" fill="#7E7E7E"></bringoz-icon>
        <span class="br-body-1 font-weight-400"
              [ngClass]="{'warn': agent.itineraryInfo?.currentLoad?.dimensionsLoadPercent > 99}"
              [ngbTooltip]="loadTooltip" openDelay="300" triggers="hover">
          {{agent.itineraryInfo?.currentLoad?.dimensionsLoadPercent > 99 ? ('Overload' | translate) : ('Normal' | translate)}}

        </span>

        <ng-template #loadTooltip>
          <div class="layout-row layout-align-start-center">
            <span translate>Volume</span>
            <span class="margin-right-5">:</span>
            <span> {{agent.itineraryInfo?.currentLoad?.dimensionsLoad?.cube}}
              / {{agent.itineraryInfo?.currentLoad?.dimensions?.cube}}</span>
          </div>
        </ng-template>


      </div>

<!--      <div *ngIf="agent.status === 'OnDutyOnBreak'" class="info-row layout-row layout-align-start-center">-->
<!--        <app-bringoz-countdown [maxCount]="agent.agentPreferencesReference?.breakDurationMinutes"-->
<!--                               [to]="agent.statusUpdatedAt + ((agent.agentPreferencesReference?.breakDurationMinutes || 0) * 60000)">-->

<!--        </app-bringoz-countdown>-->
<!--      </div>-->

    </div>
  </div>


  <div class="agent-info flex-15 layout-column layout-align-center-center">

    <div *ngIf="enableChangeDriverStatus" class="layout-row layout-align-start-center">
      <bringoz-icon *ngIf="agent.itineraryInfo.itineraryEditLockedByAdmin"
                    [ngbTooltip]="lockedByAdminTooltip"
                    openDelay="300" triggers="hover"
                    iconName="error">

      </bringoz-icon>

      <ng-template #lockedByAdminTooltip>
        <div class="tooltip-content">
          <span translate>Currently edited by</span>:
          <b>{{agent.itineraryInfo?.itineraryEditLockedByAdminName}}</b>
        </div>
      </ng-template>

      <app-agent-status [agentId]="agent.id"
                        [agentName]="agent.user | userName"
                        [status]="agent.status"
                        [statusUpdatedAt]="agent.statusUpdatedAt"
                        [activeBreakTypeId]="agent.activeBreakTypeId"
                        (onChangeStatus)="onChangeStatus.emit()">
      </app-agent-status>

    </div>

    <div *ngIf="enableDriverButton">
      <app-bringoz-state-link [state]="'agent.agent-profile'"
                              [params]="{id: agent.id}"
                              [permission]="'drivers.get'"
                              [ngbTooltip]="'Go to driver view' | translate"
                              openDelay="300" triggers="hover">
        <bringoz-icon iconName="open" class="secondary-203"></bringoz-icon>
      </app-bringoz-state-link>
    </div>

    <!--Depot Enable Button-->
    <bringoz-button *ngIf="enableItineraryButton" type="tertiary"
                    [ngbTooltip]="'Show Itinerary' | translate"
                    (onClick)="onItineraryClick.emit(agent); $event.stopPropagation();"
                    openDelay="300" triggers="hover">
    </bringoz-button>

  </div>


</div>
